import Copy from '../../assets/svgs/copy.svg';

interface LabelTextProps {
  label: string;
  value: string;
  type?: 'vertical' | 'horizontal' | 'vertical-reverse';
  allowCopy?: boolean;
}

const BaseLabelText: React.FC<LabelTextProps> = ({
  label,
  value,
  type = 'horizontal',
  allowCopy = false,
}: LabelTextProps) => {
  return (
    <div>
      {type === 'horizontal' && (
        <div className="flex items-center justify-between">
          <p className="font-semibold text-base leading-[24px]">{label}</p>
          <p className="font-light text-sm leading-[21px]">{value}</p>
        </div>
      )}
      {type === 'vertical' && (
        <div>
          <p className="font-semibold text-base leading-[24px] mb-1">{label}</p>
          <p className="font-light text-sm leading-[21px]">{value}</p>
        </div>
      )}
      {type === 'vertical-reverse' && (
        <div>
          <p className="font-light text-sm leading-[21px] mb-1">{label}</p>
          <div className="flex items-center gap-4">
            <p className="font-semibold text-base leading-[24px]">{value}</p>
            {allowCopy && (
              <img src={Copy} alt="Copy" className="cursor-pointer" />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default BaseLabelText;
